export default __webpack_public_path__ + "static/media/JIO.830d463a.png";